import React from "react";
import { FaGithub } from "react-icons/fa";
const Logo = () => {
    return (
        <div className="logo">
            <FaGithub />
        </div>
    );
};

export default Logo;
